import React, { useEffect, useState } from 'react';
import { RotationPortCall } from 'src/types/ViewModel/Stowage/Rotation/RotationPortCall';
import { useRotationStore } from 'src/context/RotationContext';
import { RotationBerthCall } from 'src/types/ViewModel/Stowage/Rotation/RotationBerthCall';
import StowageStatusIcon from 'src/components/ui/status-icon/StowageStatusIcon';
import { StowageStatusEnum } from 'src/enums/stowage/stowageStatusEnum';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useStowageStore } from 'src/context/StowageContext';
import { BurgerInfoMenu } from '../Stowage.styles';
import { TreeNode } from 'src/types/ViewModel/Stowage/TreeNode';
import { calculateRotationCallStatuses, getRotationCallStatusInBerthCall } from 'src/utils/stowage/stowageOperation/rotationCallStatusesUtils';
import { getBerthCallViolationStatus } from 'src/utils/stowage/violations/violationsUtils';
import { useViolationsStore } from 'src/context/ViolationsContext';
import { StowageRuleConsequenceType } from 'src/enums/stowage/stowageRule/stowageRuleConsequenceType';
import ViolationListIconComponent from '../violationListView/ViolationListIcon';
import { PortCallStatusEnum } from 'src/enums/stowage/portCallStatusEnum';
import { UUID } from 'crypto';
import useStowageQueryParamsUtils from 'src/utils/stowage/useStowageQueryParamsUtils';
import { useStowageSelectionStore } from 'src/context/StowageSelectionContext';
import { isManualCall } from 'src/utils/stowage/stowageRotationUtils';
import SequenceChangedIcon from 'src/components/ui/status-icon/SequenceChangedIcon';
import { StowagePlan } from 'src/types/ViewModel/Stowage/StowagePlan';
import { RotationCallStatus } from 'src/types/ViewModel/Stowage/Rotation/RotationCallStatus';
import { useVesselStore } from 'src/context/VesselContext';

type Position = {
    x: number;
    y: number;
};

type Props = {
    berthCall: RotationBerthCall;
};
const StowageRotationTreeBerthCallItemComponent: React.FC<Props> = (props) => {
    const { selectedStowageRotationBerthCall, stowageRotationTree } = useRotationStore();
    const { rotationMenuOpen, setRotationMenuOpen, activeStowagePlan, rotationCallStatuses, setRotationCallStatuses, manifest } = useStowageStore();
    const { selectedCargoOperation, setSelectedTanks } = useStowageSelectionStore();
    const { vessel } = useVesselStore();
    const [showRotationListMenuItem, setShowRotationListMenuItem] = useState<TreeNode | null>(null);
    const { setQueryParamStowageBerthCall, setQueryParamStowageCargoOperation } = useStowageQueryParamsUtils();
    const { setSelectedTab, setSelectedViolationListFilter } = useStowageSelectionStore();
    const { violations } = useViolationsStore();
    const [violationType, setViolationType] = useState<StowageRuleConsequenceType | null>(null);
    const [rotationItemPos, setRotationItemPos] = useState<Position | null>(null); // =============  Use Effects ================
    useEffect(() => {
        if (!stowageRotationTree || !activeStowagePlan || !manifest) {
            return;
        }
        const _rotationCallStatuses = calculateRotationCallStatuses(activeStowagePlan, vessel.firstVoyageOrcaWebStowageImosSync);
        setRotationCallStatuses(_rotationCallStatuses);
    }, [stowageRotationTree, activeStowagePlan, manifest]);

    useEffect(() => {
        if (violations) {
            setViolationType(getBerthCallViolationStatus(props.berthCall.berthCallGuid, violations));
        }
    }, [violations]);

    const getSelectedBerthCallClass = (berthCallItem: RotationBerthCall) => {
        if (selectedStowageRotationBerthCall && selectedStowageRotationBerthCall.berthCallGuid === berthCallItem.berthCallGuid) {
            return 'is-selected-berth-call';
        }

        return '';
    };

    const getContextMenuOpenClass = (berthCallItem: RotationBerthCall) => {
        if (rotationMenuOpen?.isVisible && rotationMenuOpen?.berthCall?.berthCallGuid === berthCallItem.berthCallGuid) {
            return 'context-menu-open';
        }

        return '';
    };

    const getDepartedBerthCallClass = () => {
        return props.berthCall.portCall.portCallStatus === PortCallStatusEnum.Departed ? 'departed-berth-call' : '';
    };

    const onShowRotationMenu = (event: any, portCall: RotationPortCall | null, bertCall: RotationBerthCall | null) => {
        event.preventDefault();
        event.stopPropagation();

        if (rotationMenuOpen && rotationMenuOpen.isVisible) {
            setRotationMenuOpen(null);
        } else {
            const yPos = rotationItemPos.y;
            const menuItem = { isVisible: true, top: yPos, portCall: portCall, berthCall: bertCall };

            setRotationMenuOpen(menuItem);
        }
    };

    const onMouseEnterRotationListItem = (event: any, guid: UUID, rotationNodeType: string) => {
        event.preventDefault();
        event.stopPropagation();
        const xPos = event.clientX;
        let yPos = event.clientY;

        if (event.clientY + 380 > window.innerHeight) {
            const yDiff = window.innerHeight - 380;
            yPos = yDiff;
        }

        setRotationItemPos({ x: xPos, y: yPos });

        const hoverTreeNode: TreeNode = { guid, type: rotationNodeType };

        setShowRotationListMenuItem(hoverTreeNode);
    };

    const onMouseLeaveRotationListItem = (event: any) => {
        event.preventDefault();
        event.stopPropagation();
        setShowRotationListMenuItem(null);
    };

    const onSelectedBerthCall = (event: any, berthCall: RotationBerthCall) => {
        event.preventDefault();
        event.stopPropagation();
        if (selectedCargoOperation && berthCall.cargoOperations.find((co) => co.cargoOperationGuid === selectedCargoOperation.cargoOperationGuid)) {
            setQueryParamStowageCargoOperation(berthCall.portCall.portCallGuid, selectedCargoOperation.cargoOperationGuid, berthCall.berthCallGuid);
        } else {
            setQueryParamStowageBerthCall(berthCall.portCall.portCallGuid, berthCall.berthCallGuid);
        }
        setSelectedTanks([]);
    };

    const getDefaultBerthItemCssClasses = () => {
        const cssClasses = 'rotation-tree-item berth-node berth-call-item  text-overflow ';

        return cssClasses;
    };

    const onViewViolationsForSelectedCall = () => {
        setSelectedTab('Violation List');
        setSelectedViolationListFilter('Selected call');
    };

    const getBerthCallStatusIcon = (
        berthCallItem: RotationBerthCall,
        activeStowagePlan: StowagePlan,
        rotationCallStatuses: RotationCallStatus[]
    ): any => {
        if (!activeStowagePlan) {
            return;
        }

        const status = getRotationCallStatusInBerthCall(rotationCallStatuses, berthCallItem.berthCallGuid);

        if (status?.numberOfCargoOperationsWithMissingStowage === 0 && status?.numberOfCargoOperations > 0) {
            return StowageStatusIcon(StowageStatusEnum.Stowed, null);
        } else if (status?.numberOfCargoOperationsWithMissingStowage > 0 && status?.numberOfCargoOperations > 0) {
            return StowageStatusIcon(StowageStatusEnum.MissingStowage, status.numberOfCargoOperationsWithMissingStowage);
        } else if (status?.numberOfCargoOperations === 0) {
            return StowageStatusIcon(StowageStatusEnum.NotApplicable, null);
        }
    };

    return (
        <li
            onClick={(e) => onSelectedBerthCall(e, props.berthCall)}
            onContextMenu={(e) => onShowRotationMenu(e, null, props.berthCall)}
            tabIndex={0}
            onMouseEnter={(e) => onMouseEnterRotationListItem(e, props.berthCall.berthCallGuid, 'BerthCall')}
            onMouseLeave={(e) => onMouseLeaveRotationListItem(e)}
            className={getDefaultBerthItemCssClasses() + getSelectedBerthCallClass(props.berthCall) + ' ' + getContextMenuOpenClass(props.berthCall)}
            key={`b-` + props.berthCall.berthCallGuid}
        >
            <span className={'berth-name text-overflow' + ' ' + getDepartedBerthCallClass()}>{props.berthCall.berthName}</span>
            <span className="icon-wrapper">
                {isManualCall(props.berthCall) && <div className="manual-node-marker">M</div>}
                <SequenceChangedIcon hasChangedSequence={props.berthCall.hasChangedSequence} />
                <span onClick={onViewViolationsForSelectedCall}>
                    <ViolationListIconComponent violationType={violationType} includeText={false} />
                </span>
                <span className="status-icon">{getBerthCallStatusIcon(props.berthCall, activeStowagePlan, rotationCallStatuses)}</span>
                <BurgerInfoMenu
                    onClick={(e) => onShowRotationMenu(e, null, props.berthCall)}
                    className={
                        showRotationListMenuItem?.type === 'BerthCall' && showRotationListMenuItem?.guid === props.berthCall.berthCallGuid
                            ? 'show-menu'
                            : ''
                    }
                >
                    <FontAwesomeIcon icon="ellipsis-h" />
                </BurgerInfoMenu>
            </span>
        </li>
    );
};

export default StowageRotationTreeBerthCallItemComponent;
